export default (elements, parentId) => {
  const branch = []
  elements.forEach((element) => {
    if (element.parent_id === parentId) {
      const children = this(elements, element.id)
      if (children) {
        element.children = children
      }
      branch[element.id] = element
    }
  })
  return branch
}
